import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function dm_vac_05_page_cards() {
    $('.vac-05-page-cards').each(function() {
        const $section = $(this);
        const swipers = new Map();

        $section.find('.vac-05-swiper').each(function() {
            const $slider = $(this).closest('.vac-05-slider');
            const previousButton = $slider.find('.swiper-button-prev')[0];
            const nextButton = $slider.find('.swiper-button-next')[0];
            const options = {
                modules: [Navigation],
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 700,
                watchOverflow: true,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: 3,
                    },
                },
            };

            if (previousButton && nextButton) {
                options.navigation = {
                    prevEl: previousButton,
                    nextEl: nextButton,
                };
            }

            const swiper = new Swiper(this, options);
            const paneIndex = $(this).closest('.vac-05-tab-pane').attr('data-index');

            if (paneIndex) {
                swipers.set(paneIndex, swiper);
            }
        });

        $section.find('.tab-filter').on('click', function() {
            const index = $(this).attr('data-index');

            $section.find('.tab-filter')
                .removeClass('is-active')
                .attr('aria-selected', 'false');
            $(this)
                .addClass('is-active')
                .attr('aria-selected', 'true');

            $section.find('.vac-05-tab-pane').each(function() {
                const isActive = $(this).attr('data-index') === index;

                $(this)
                    .toggleClass('is-active', isActive)
                    .prop('hidden', !isActive);
            });

            const swiper = swipers.get(index);

            if (swiper) {
                requestAnimationFrame(() => swiper.update());
            }
        });
    });
}

export { dm_vac_05_page_cards };